// Firebase keeps the user on this exact code during its own initialization.
// Other refresh rejections can mean a dead credential and keep their old path.
export const isNetworkAuthError = (error: unknown): boolean =>
  typeof error === 'object' && error !== null && 'code' in error &&
  error.code === 'auth/network-request-failed';
